module.exports = __webpack_public_path__ + "static/img/line-setting-2.450c349.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/line-setting-2.png
// module id = JvRv
// module chunks = 31